import { render, staticRenderFns } from "./StringTextarea.vue?vue&type=template&id=03ec2635&"
import script from "./StringTextarea.vue?vue&type=script&lang=js&"
export * from "./StringTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports